/**
 * @generated SignedSource<<34eaf41991f99f2d4401a4cd7ea70c95>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type fieldLabel_AtlassianConversationAssistantPreviewCard$data = {
  readonly fieldConfig?: {
    readonly isRequired: boolean | null;
  } | null;
  readonly name: string;
  readonly " $fragmentType": "fieldLabel_AtlassianConversationAssistantPreviewCard";
};
export type fieldLabel_AtlassianConversationAssistantPreviewCard$key = {
  readonly " $data"?: fieldLabel_AtlassianConversationAssistantPreviewCard$data;
  readonly " $fragmentSpreads": FragmentRefs<"fieldLabel_AtlassianConversationAssistantPreviewCard">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "fieldLabel_AtlassianConversationAssistantPreviewCard",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "name"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "concreteType": "JiraFieldConfig",
          "kind": "LinkedField",
          "name": "fieldConfig",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "isRequired"
            }
          ]
        }
      ],
      "type": "JiraIssueFieldConfiguration",
      "abstractKey": "__isJiraIssueFieldConfiguration"
    }
  ],
  "type": "JiraIssueField",
  "abstractKey": "__isJiraIssueField"
};

(node as any).hash = "5dbc4ccc26c8e0c2514a3bba87465edc";

export default node;
